<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="addGatewayForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.keycode, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.keycode, 'label')">{{ 'KEYCODE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.keycode, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="gateway-add-input-keycode"
							formControlName="keycode" autocomplete="gateway-keycode" placeholder="{{ 'KEYCODE' | translate }}"
							maxlength="16" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.keycode)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'INVALID_KEYCODE' | translate }}</small>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="gateway-add-input-name"
							formControlName="name" autocomplete="gateway-name" placeholder="{{ 'NAME' | translate }}"
							maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.description, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="gateway-add-input-description"
							formControlName="description" autocomplete="gateway-description"
							placeholder="{{ 'DESCRIPTION' | translate }}" maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.description)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>